module.exports = __webpack_public_path__ + "static/media/HeroImage.668fb707.jpg";